import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { notifications } from '@mantine/notifications';
import { performLogout } from '../services/userManager';

export default function Logout() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // Perform logout
    const handleLogout = async () => {
      const serverLogoutSuccess = await performLogout();

      // Show notification
      notifications.show({
        color: 'blue',
        title: t('logged_out', 'Disconnesso'),
        message: t('logged_out_message', 'Sei stato disconnesso con successo'),
      });

      // Redirect to login page
      navigate('/login', { replace: true });

      // Show warning notification if server logout failed
      if (!serverLogoutSuccess) {
        notifications.show({
          color: 'orange',
          withBorder: true,
          radius: 'lg',
          title: 'Warning',
          autoClose: 5000,
          message: 'Logged out locally, but server logout failed',
        });
      }
    };

    // Execute logout immediately
    handleLogout();
  }, [navigate, t]);

  // This component doesn't render anything as it immediately redirects
  return null;
}
